// FIXME: Update this file to be type safe and remove this and next line
// @ts-strict-ignore
export class OrganizationUserAcceptRequest {
  token: string;
  // Used to auto-enroll in master password reset
  resetPasswordKey: string;
}
